import Ace from 'ace-builds';

// HTML mode
Ace.config.setModuleUrl(
  'ace/mode/html',
  require('file-loader?outputPath=js!ace-builds/src-noconflict/mode-html')
);
Ace.config.setModuleUrl(
  'ace/mode/html_worker',
  require('file-loader?outputPath=js!ace-builds/src-noconflict/worker-html')
);

// JavaScript mode
Ace.config.setModuleUrl(
  'ace/mode/javascript',
  require('file-loader?outputPath=js!ace-builds/src-noconflict/mode-javascript')
);
Ace.config.setModuleUrl(
  'ace/mode/javascript_worker',
  require('file-loader?outputPath=js!ace-builds/src-noconflict/worker-javascript')
);

// Chrome theme
Ace.config.setModuleUrl(
  'ace/theme/chrome',
  require('file-loader?outputPath=js!ace-builds/src-noconflict/theme-chrome')
);

export default Ace;
